import { Input, Select, styled } from '@mui/material';
import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';

const UserSelectTenantInput = styled(Input)(({ theme }) => ({
  ...theme.typography.caption,
}));

export default function UserSwitchTenant({
  tenants,
  tenantId,
  onChange,
}: {
  tenants: { tenantId: string; name: string }[];
  tenantId: string;
  onChange: (tenantId: string) => void;
}) {
  return (
    <Select
      disableUnderline
      defaultValue={tenantId}
      IconComponent={(props) => <ArrowDropDownIcon {...props} fontSize="small" />}
      onChange={(e) => onChange(e.target.value)}
      input={<UserSelectTenantInput />}
      native
    >
      {tenants.map((t) => (
        <option key={t.tenantId} value={t.tenantId}>
          {t.name}
        </option>
      ))}
    </Select>
  );
}
